import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import vueNiceScrollbar from 'vue-nice-scrollbar'
import vueCustomElement from 'vue-custom-element';
// /**
//  * NOTE: If you are using other transition them make sure to import it in `src/@core/scss/vue/libs/notification.scss` from it's source
//  */
Vue.use(vueCustomElement)
Vue.use(vueNiceScrollbar)

Vue.use(Vuex)
// Social Login Auth Ruhul
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import VueSocialauth from 'vue-social-auth'
import { studyPressBaseUrl } from '@/config/api_config'
Vue.use(VueSocialauth, {
  providers: {
    google: {
      clientId: '989347957988-ubssiic7v9n2mk9ni01o4ihg1sn47e2v.apps.googleusercontent.com',
      // redirectUri: `${studyPressBaseUrl}auth/google/callback` // Your client app URL
      redirectUri: `${studyPressBaseUrl}site/dashboard` // Your client app URL
      // redirectUri: 'http://localhost:8000/auth/google/callback' // Your client app URL
    },
    facebook: {
      clientId: '1252863972315646',
      // redirectUri: `${studyPressBaseUrl}auth/facebook/callback` // Your client app URL
      redirectUri: `${studyPressBaseUrl}site/dashboard` // Your client app URL
      // redirectUri: 'http://localhost:8000/auth/facebook/callback' // Your client app URL
    }
  }
})

import VuePaginateScroll from "vue-paginate-scroll"
Vue.component('vue-paginate-scroll', VuePaginateScroll)

import { BootstrapVue, IconsPlugin, ToastPlugin, ModalPlugin } from 'bootstrap-vue'
// import BootstrapVue, { IconsPlugin, ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// import i18n from '@/libs/i18n'
// import router from './router'
// import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

// BSV Plugin Registration
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// VueSweetalert2
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

// ntrca
// require('@core/ntrca-assets/css/pico.min.css')
// require('@core/ntrca-assets/css/pico-bootstrap-grid.min.css')
// require('@core/ntrca-assets/css/index.css')

const options = {
  confirmButtonColor: '#28C76F',
  cancelButtonColor: '#d33',
}

Vue.use(VueSweetalert2, options)

Vue.filter('dateFormat', function(value) {
  //moment.locale();
  return moment(value).format('DD-MM-YYYY')
})

Vue.filter('dateFormatInMonth', function(value) {
  //moment.locale();
  return moment(value).format('MMMM Do, YYYY')
})

Vue.filter('timeFormat', function(value) {
  return moment(value).format('h:mm A')
})

Vue.filter('dateTimeFormat', function(value) {
  return moment(value).format('DD-MM-YYYY, h:mm A')
})

Vue.filter('currentDate', function() {
    //moment.locale();
    var now = moment()
    return moment(now).format('DD-MM-YYYY, h:mm A')
});

Vue.config.productionTip = false
Vue.customElement('studypress-app', App, {})
// const vm = new Vue({
//   router,
//   store,
//   i18n,
//   render: h => h(App),
// }).$mount('#app')

// window.vm = vm
